import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { APP_ID, LOCALE_ID, NgModule, isDevMode } from '@angular/core';
import { RouterModule } from '@angular/router';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { MatAnchor } from "@angular/material/button";
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { NgxMaskConfig, provideEnvironmentNgxMask } from 'ngx-mask';
import { EventEffects } from 'src/app/core/store/event/event.effecs';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CountryEffect } from './core/store/country/country.effecs';
import { countryReducer } from './core/store/country/country.reducer';
import { eventReducer } from './core/store/event/event.reducer';
import { MissionEffects } from './core/store/mission/mission.effecs';
import { missionReducer } from './core/store/mission/mission.reducer';
import { organisationReducer } from './core/store/organisation/organisation.reducer';
import { OrganisationEffects } from './core/store/organisation/organsation.effecs';
import { RaceEffect } from './core/store/race/race.effecs';
import { raceReducer } from './core/store/race/race.reducer';
import { TimezoneEffect } from './core/store/timezone/timezone.effecs';
import { timezoneReducer } from './core/store/timezone/timezone.reducer';
import { userReducer } from './core/store/userData/userdata.reducer';
import { volunteersReducer } from './core/store/volunteer/volunteer.reducer';
import { VolunteerEffects } from './core/store/volunteer/volunteers.effecs';
import { FooterComponent } from './footer/footer.component';
import { HomeModule } from './home/home.module';
import { LegalsMentionsComponent } from './legals-mentions/legals-mentions.component';
import { MainHeaderComponent } from './main-header/main-header.component';
import { RaceComponent } from './race/race.component';
import { HeaderModule } from "./shared/component/header/header.module";
import { NewsletterModule } from './shared/component/newsletter/newsletter.module';
import { LoadingSpinnerModule } from "./shared/design-system/loading-spinner/loading-spinner.module";

const maskConfigFunction: () => Partial<NgxMaskConfig> = () => {
    return {
        validation: true,
    };
};

registerLocaleData(localeFr);

@NgModule({
    declarations: [
        AppComponent,
        MainHeaderComponent,
        FooterComponent,
        LegalsMentionsComponent,
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HomeModule,
        RouterModule,
        MatDialogModule,
        RaceComponent,
        NewsletterModule,
        MatSnackBarModule,
        MatIconModule,
        LoadingSpinnerModule,
        StoreModule.forRoot({
            volunteers: volunteersReducer,
            missions: missionReducer,
            events: eventReducer,
            user: userReducer,
            organisations: organisationReducer,
            races: raceReducer,
            countries: countryReducer,
            timezones: timezoneReducer,
        }),
        EffectsModule.forRoot([
            VolunteerEffects,
            MissionEffects,
            OrganisationEffects,
            EventEffects,
            RaceEffect,
            CountryEffect,
            TimezoneEffect,
        ]),
        StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: true }),
        LoadingSpinnerModule,
        StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode() }),
        HeaderModule,
        MatAnchor
    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'fr-FR' },
        { provide: APP_ID, useValue: 'serverApp' },
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
        { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2500 } },
        provideHttpClient(withInterceptorsFromDi(), withFetch()),
        provideEnvironmentNgxMask(maskConfigFunction),
    ]
})
export class AppModule { }
